import React from "react";
import axios from "axios";
import { baseurl } from "../../constant";
export const PenneyDropApiDocument = () => {
  // const [data, setdats] = useState();
  // const [url, setUrl] = useState();
  // console.log(data);
  // const token = localStorage.getItem("authToken");

  // const submitCallbackurl = async () => {
  //   const result = await axios.post(baseurl + "callbackUpdateAuth", {
  //     token: token,
  //     type: 1,
  //     url: url,
  //   });
  //   setdats(result.data);
  // };

  return (
    <div>
      <div className="card shadow mb-4">
        <form
          id="admin_profile"
          enctype="multipart/form-data"
          method="post"
          accept-charset="utf-8"
        >
          <input type="hidden" name="method" value="post" />
          <div className="card-header py-3">
            <h4
              style={{
                backgroundColor: "#d2f4e8",
                borderColor: "#bff0de",
                color: "green",
              }}
            ></h4>

            <div className="row">
              <div className="col-sm-8">
                <h4>
                  <b>Penny Drop API Document</b>
                </h4>
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className="row">
              <div className="col-sm-12">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      id="rechargeAPI-tab"
                      data-toggle="tab"
                      href="#rechargeAPI"
                      role="tab"
                      aria-controls="rechargeAPI"
                      aria-selected="true"
                    >
                      Penny Drop API
                    </a>
                  </li>
                </ul>
                <div className="tab-content apidoc" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="rechargeAPI"
                    role="tabpanel"
                    aria-labelledby="rechargeAPI-tab"
                  >
                    <div className="col-sm-12">
                      <br />
                      <h1>Request API URL</h1>
                      <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                        https://www.payol.in/portal/api/pennyDrop
                      </p>
                      <hr />
                      <p>
                        <b>Request Method - POST</b>
                      </p>
                    </div>
                    <div className="col-sm-12">
                      <br />
                      <h1>Header Parameter</h1>
                      <table className="table table-bordered table-striped">
                        <tr>
                          <th>#</th>
                          <th>Parameter Key</th>
                          <th>Description</th>
                        </tr>
                        <tr>
                          <td>1.</td>
                          <td>Memberid</td>
                          <td>Your account unique id.</td>
                        </tr>
                        <tr>
                          <td>2.</td>
                          <td>Txnpwd</td>
                          <td>Your account trasaction password.</td>
                        </tr>
                      </table>
                      <p style={{ color: "red" }}>
                        Note:- All Parameter key are case sensitive.
                      </p>
                    </div>
                    <div className="col-sm-12">
                      <br />
                      <h1>Post Parameter</h1>
                      <table className="table table-bordered table-striped">
                        <tr>
                          <th>#</th>
                          <th>Parameter Key</th>
                          <th>Description</th>
                        </tr>
                        {/* <!-- <tr>
                                           <td>1.</td>
                                           <td>mobile</td>
                                           <td>Customer Mobile No.</td>
                                         </tr> --> */}
                        <tr>
                          <td>1.</td>
                          <td>account_holder_name</td>
                          <td>Account Holder Name</td>
                        </tr>
                        <tr>
                          <td>2.</td>
                          <td>account_number</td>
                          <td>Customer Account No.</td>
                        </tr>
                        <tr>
                          <td>3.</td>
                          <td>ifsc</td>
                          <td>Customer Bank IFSC Code.</td>
                        </tr>

                        <tr>
                          <td>4.</td>
                          <td>txnID</td>
                          <td>Unique Trasaction ID(Min Length 10 )</td>
                        </tr>
                        <tr>
                          <td>6.</td>
                          <td>response_type</td>
                          <td>
                            1 for JSON, 2 for XML. Default Response Will be in
                            JSON Format
                          </td>
                        </tr>
                      </table>
                      <p style={{ color: "red" }}>
                        Note:- All Parameter key are case sensitive.
                      </p>
                    </div>

                    <div className="col-sm-12">
                      <br />
                      <h1>JSON Response</h1>
                      <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                        {"{"} <br />
                        "status_code": 200,
                        <br />
                        "status_msg": "OK",
                        <br />
                        "status": "SUCCESS", <br />
                        "txnid": 16131198309337,
                        <br />
                        "account_holder_name : Test",
                        <br />
                        "account_number":1221108115222TYNUH
                        <br />
                        "opt_msg" : "Transaction Successful"
                        <br />
                        {"}"}
                      </p>
                    </div>

                    <div className="col-sm-12">
                      <br />
                      <h1>XML Response</h1>
                      <p style={{ fontSize: "18px", whiteSpace: "pre" }}>
                        &#60;?xml version="1.0"?&#62; &#60;response&#62;
                        <br />
                        &#60;status_code&#62;200&#60;/status_code&#62;
                        <br />
                        &#60;status_msg&#62;OK&#60;/status_msg&#62;
                        <br />
                        &#60;status&#62;FAILED&#60;/status&#62;
                        <br />
                        &#60;txnid&#62;1234567890&#60;/txnid&#62;
                        <br />
                        &#60;account_holder_name&#62;Test&#60;/account_holder_name&#62;
                        <br />
                        &#60;/response&#62;
                        <br />
                      </p>
                    </div>

                    <div className="col-sm-12">
                      <br />
                      <h1>Response Parameters</h1>
                      <table className="table table-bordered table-striped">
                        <tr>
                          <th>#</th>
                          <th>Parameter Key</th>
                          <th>Description</th>
                        </tr>
                        <tr>
                          <td>1.</td>
                          <td>status_code</td>
                          <td>
                            400 = Variable Related Error <br />
                            401 = Variable Data Related Error <br />
                            200 = Success
                          </td>
                        </tr>
                        <tr>
                          <td>2.</td>
                          <td>status_msg</td>
                          <td>
                            API Success or Error Message according status code.
                          </td>
                        </tr>
                        <tr>
                          <td>3.</td>
                          <td>status</td>
                          <td>
                            PENDING <br />
                            FAILED <br />
                            SUCCESS
                          </td>
                        </tr>
                        <tr>
                          <td>4.</td>
                          <td>txnid</td>
                          <td>Your Unique Trasaction ID.</td>
                        </tr>
                        <tr>
                          <td>5.</td>
                          <td>optxid</td>
                          <td>Unique Trasaction ID from Operator Side.</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>{" "}
      </div>
    </div>
  );
};
export default PenneyDropApiDocument;
